import { useState, useEffect } from "react";

export function useLocalStorageState(initialState, key) {
  const [value, setValue] = useState(function () {
    const storedValue = localStorage.getItem(key);
    return storedValue? JSON.parse(storedValue):initialState ;
  });

  useEffect(
    () => localStorage.setItem(key, JSON.stringify(value)), // Use the 'key' parameter here
    [value, key]
  );

  return [value, setValue];
}
